import {gettext} from 'topmeteo/utils/i18n';

import Overview from './Overview';
import PopUp from './PopUp';

const Headline = gettext('Forecast regions');

const RegionMap = ({overview, active, onOpen, onClose}) => (
    <div className="region-map">
        <h3>{Headline}</h3>
        <Overview {...overview} onClick={onOpen} />
        <PopUp {...overview} active={active} onClose={onClose} headline={Headline} />
        <div className="lightbox-overlay" onClick={onClose} />
    </div>
);

export default RegionMap;
